"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_SUCCESSFUL = exports.UPDATE_PENDING = exports.UPDATE_FAILED = void 0;
var UPDATE_PENDING = exports.UPDATE_PENDING = 'pending';
var UPDATE_SUCCESSFUL = exports.UPDATE_SUCCESSFUL = 'successful';
var UPDATE_FAILED = exports.UPDATE_FAILED = 'failed';